import DataTable from 'libs/kd_data_table/data-table';
export default class extends DataTable {
  constructor() {
    let data = {
      lectures_ids: [1, 2, 15, 16, 17],
      lectures: [
        {
          id: 1,
          course_id: 1,
          title: 'Sometimes We Looked With a Pretty Long Name Something That should get cut off at some point',
          order: 1,
          coursework: '',
          visible_on: '02/10/2017 11:52 PM',
          meeting_start: '02/02/2017 11:52 AM',
          meeting_end: '02/16/2017 11:52 PM',
          description: 'ehe',
          status: 'Draft',
          edit_session_path: '/courses/robotics-iv/sessions/sometimes-we-looked/edit',
          delete_lecture_path: '/courses/robotics-iv/sessions/sometimes-we-looked',
          allow_destroy: true
        },
        {
          id: 2,
          course_id: 1,
          title: 'Therefore It He',
          order: 2,
          coursework: '',
          visible_on: '02/10/2017 11:52 PM',
          meeting_start: '02/02/2017 11:52 AM',
          meeting_end: '02/16/2017 11:52 PM',
          status: 'Published',
          edit_session_path: '/courses/robotics-iv/sessions/therefore-it-he/edit',
          delete_lecture_path: '/courses/robotics-iv/sessions/therefore-it-he',
          allow_destroy: true,
          description: ''
        },
        {
          id: 15,
          course_id: 1,
          title: 'asdfasdf',
          order: 3,
          coursework: '',
          visible_on: '02/08/2017 11:52 PM',
          meeting_start: '02/02/2017 11:52 AM',
          meeting_end: '02/16/2017 11:52 PM',
          description: 'Sick stugg',
          status: 'Draft',
          edit_session_path: '/courses/robotics-iv/sessions/asdfasdf/edit',
          delete_lecture_path: '/courses/robotics-iv/sessions/asdfasdf',
          allow_destroy: true
        },
        {
          id: 16,
          course_id: 1,
          title: 'asdasd',
          order: 4,
          coursework: '',
          visible_on: '02/10/2017 11:52 PM',
          meeting_start: '02/02/2017 11:52 AM',
          meeting_end: '02/16/2017 11:52 PM',
          description: 'kcasjdnfask',
          status: 'Draft',
          edit_session_path: '/courses/robotics-iv/sessions/asdasd/edit',
          delete_lecture_path: '/courses/robotics-iv/sessions/asdasd',
          allow_destroy: true
        },
        {
          id: 17,
          course_id: 1,
          title: 'asd',
          order: 5,
          coursework: '',
          visible_on: '02/10/2017 11:52 PM',
          meeting_start: '02/02/2017 11:52 AM',
          meeting_end: '02/16/2017 11:52 PM',
          description: 'asdgasgrw',
          status: 'Draft',
          edit_session_path: '/courses/robotics-iv/sessions/asd/edit',
          delete_lecture_path: '/courses/robotics-iv/sessions/asd',
          allow_destroy: true
        }
      ],
      total_lectures: '23'
    };
    let options = {
      dataset_name: 'lectures',
      table_properties: {
        creatable: { enabled: true },
        paginatable: { enabled: true },
        searchable: { enabled: true }
        //timezone: 'PDT'
      },
      // Column names that will get mapped to the table
      // 'property' should have the same name as the key in the data
      // You can pass custom names as well
      // 'width' can be set to 'primary' or 'date' which will determine how big
      // the width of the column will be. You can also leave this blank
      columns: [
        {
          name: 'Session',
          property: 'title',
          width: 'primary',
          hideable: false,
          editable: {
            type: 'text'
          },
          sortable: {
            default: true,
            type: 'string',
            dragOverride: true
          }
        },
        {
          property: 'visible_on',
          width: 'date_long',
          editable: {
            type: 'date'
          },
          sortable: {
            type: 'date'
          }
        },
        {
          property: 'meeting_start',
          width: 'date_long',
          editable: {
            type: 'date'
          },
          sortable: {
            type: 'date'
          }
        },
        {
          property: 'meeting_end',
          width: 'date_long',
          editable: {
            type: 'date'
          },
          sortable: {
            type: 'date'
          }
        },
        {
          property: 'status',
          editable: {
            type: 'dropdown',
            dropdown_options: ['published', 'draft']
          },
          sortable: {
            type: 'string'
          }
        },
        {
          property: 'description',
          sortable: {
            type: 'string'
          }
        }
      ],
      column_properties: {
        hideable: {
          enabled: true,
          default_columns: ['title', 'status', 'meeting_start', 'meeting_end']
        },
        sortable: { enabled: true },
        editable: { enabled: true }
      },
      row_properties: {
        removable: { enabled: true },
        draggable: {
          enabled: true,
          update_url: '/'
        }
      }
    };
    let el = document.getElementById('example-data-table');

    // Uncomment this to see table's empty state
    // data.lectures = [];

    super(data, el, options);
    console.log('constructor called for Kadenze.CommonStyleGuideKdDataTable');
  }
}

